import React from 'react'

const MaterialSetDesktopBackground = () => (
  <svg
    width="525"
    height="528"
    viewBox="0 0 525 528"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <ellipse cx="180" cy="213" rx="345" ry="315" fill="currentColor" fillOpacity="0.05" />
  </svg>
)

export default MaterialSetDesktopBackground
